import { Industry } from '../types';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

interface IndustryHeroProps {
  industry: Industry;
  onRequestDemo: () => void;
  onCalculateROI: () => void;
}

const IndustryHero = ({ industry, onRequestDemo, onCalculateROI }: IndustryHeroProps) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 pt-24 pb-16 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full">
              <Icon name={industry.icon} size={20} className="text-primary" />
              <span className="text-sm font-semibold text-primary">{industry.name}</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              {industry.tagline}
            </h1>
            
            <p className="text-lg text-text-secondary leading-relaxed">
              {industry.description}
            </p>
            
            <div className="space-y-3">
              {industry.keyBenefits.map((benefit, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-success/20 flex items-center justify-center mt-0.5">
                    <Icon name="Check" size={14} className="text-success" />
                  </div>
                  <span className="text-foreground">{benefit}</span>
                </div>
              ))}
            </div>
            
            {/* <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                variant="default"
                size="lg"
                iconName="Play"
                iconPosition="left"
                onClick={onRequestDemo}
                className="animate-pulse-subtle"
              >
                Request Live Demo
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Calculator"
                iconPosition="left"
                onClick={onCalculateROI}
              >
                Calculate ROI
              </Button>
            </div> */}
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-secondary/20 rounded-2xl blur-3xl"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-brand-lg">
              <Image
                src={industry.heroImage}
                alt={industry.heroImageAlt}
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryHero;